import api from './api';

const adminService = {
  // Get all users
  getAllUsers: async () => {
    const response = await api.get('/users');
    return response.data;
  },

  // Create a new user
  createUser: async (userData) => {
    const response = await api.post('/users', userData);
    return response.data;
  },

  // Update a user
  updateUser: async (userId, userData) => {
    const response = await api.put(`/users/${userId}`, userData);
    return response.data;
  },

  // Delete a user
  deleteUser: async (userId) => {
    const response = await api.delete(`/users/${userId}`);
    return response.data;
  },

  // Get current user info
  getCurrentUser: async () => {
    const response = await api.get('/users/me');
    return response.data;
  },

  // Admin reset user password
  resetUserPassword: async (userId, newPassword) => {
    const response = await api.post(`/users/${userId}/reset-password`, {
      new_password: newPassword
    });
    return response.data;
  },

  // Invite a new user
  inviteUser: async (email, role, sendEmail = true) => {
    const response = await api.post('/users/invite', {
      email,
      role,
      send_email: sendEmail
    });
    return response.data;
  },

  // Get pending invitations
  getInvitations: async () => {
    const response = await api.get('/users/invitations');
    return response.data;
  },

  // Revoke an invitation
  revokeInvitation: async (invitationId) => {
    const response = await api.delete(`/users/invitations/${invitationId}`);
    return response.data;
  },

  // Activate a user
  activateUser: async (userId) => {
    const response = await api.patch(`/users/${userId}/activate`);
    return response.data;
  },

  // Deactivate a user
  deactivateUser: async (userId) => {
    const response = await api.patch(`/users/${userId}/deactivate`);
    return response.data;
  }
};

export default adminService;
